var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "search-form",
        {
          attrs: { formConfig: _vm.formConfig, source: _vm.searchData },
          on: { search: _vm.search, handleSearch: _vm.handleSearch }
        },
        [
          _vm.formBtns.indexOf("exportBtn") > -1
            ? _c(
                "template",
                { slot: "btns" },
                [
                  _c(
                    "a-button",
                    {
                      staticClass: "search-btn-item",
                      attrs: { type: "primary" },
                      on: { click: _vm.onExport }
                    },
                    [_vm._v("导出")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.formBtns.indexOf("importBtn") > -1
            ? _c(
                "template",
                { slot: "btns" },
                [
                  _c(
                    "a-button",
                    {
                      staticClass: "search-btn-item",
                      attrs: { type: "primary" },
                      on: { click: _vm.onImport }
                    },
                    [_vm._v("导入发票")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.formBtns.indexOf("addContract") > -1
            ? _c(
                "template",
                { slot: "btns" },
                [
                  _c(
                    "a-button",
                    {
                      staticClass: "search-btn-item",
                      attrs: {
                        type: "primary",
                        disabled: _vm.selectedRowKeys.length == 0
                      },
                      on: {
                        click: function($event) {
                          return _vm.addContract()
                        }
                      }
                    },
                    [_vm._v("匹配合同")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.formBtns.indexOf("delContract") > -1
            ? _c(
                "template",
                { slot: "btns" },
                [
                  _c(
                    "a-button",
                    {
                      staticClass: "search-btn-item",
                      attrs: {
                        type: "primary",
                        disabled: _vm.selectedRowKeys.length == 0
                      },
                      on: {
                        click: function($event) {
                          return _vm.delContract()
                        }
                      }
                    },
                    [_vm._v("解除合同")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.formBtns.indexOf("addvoucher") > -1
            ? _c(
                "template",
                { slot: "btns" },
                [
                  _c(
                    "a-button",
                    {
                      staticClass: "search-btn-item",
                      attrs: {
                        type: "primary",
                        disabled: _vm.selectedRowKeys.length == 0
                      },
                      on: {
                        click: function($event) {
                          return _vm.toDeliveryCreate("add")
                        }
                      }
                    },
                    [_vm._v("匹配凭证")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.formBtns.indexOf("revokeBtn") > -1
            ? _c(
                "template",
                { slot: "btns" },
                [
                  _c(
                    "a-button",
                    {
                      staticClass: "search-btn-item btn-red-line",
                      attrs: { disabled: _vm.selectedRowKeys.length == 0 },
                      on: {
                        click: function($event) {
                          return _vm.cancel("撤销")
                        }
                      }
                    },
                    [_vm._v("撤销")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.formBtns.indexOf("applyBtn") > -1
            ? _c(
                "template",
                { slot: "btns" },
                [
                  _c(
                    "a-button",
                    {
                      staticClass: "search-btn-item",
                      attrs: {
                        type: "primary",
                        disabled: _vm.selectedRowKeys.length == 0
                      },
                      on: { click: _vm.systemCheck }
                    },
                    [_vm._v("平台查验")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.formBtns.indexOf("applyUserBtn") > -1
            ? _c(
                "template",
                { slot: "btns" },
                [
                  _c(
                    "a-button",
                    {
                      staticClass: "search-btn-item",
                      attrs: {
                        type: "primary",
                        disabled: _vm.selectedRowKeys.length == 0
                      },
                      on: { click: _vm.selfCheck }
                    },
                    [_vm._v("自助查验")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.formBtns.indexOf("deletBtn") > -1
            ? _c(
                "template",
                { slot: "btns" },
                [
                  _c(
                    "a-button",
                    {
                      staticClass: "search-btn-item btn-red-line",
                      attrs: { disabled: _vm.selectedRowKeys.length == 0 },
                      on: {
                        click: function($event) {
                          return _vm.cancel("删除")
                        }
                      }
                    },
                    [_vm._v("删除")]
                  ),
                  _vm._v(" "),
                  _vm.selectedRowKeys.length > 0 &&
                  _vm.formBtns.indexOf("applyBtn") > -1
                    ? _c("span", { staticClass: "text-color-orange" }, [
                        _vm._v(
                          "温馨提示：若信息无误，自助查验仍不通过，可申请平台平台查验"
                        )
                      ])
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _vm.formBtns.indexOf("openGold") > -1
        ? _c(
            "div",
            {
              staticStyle: {
                padding: "15px 0 0 10px",
                background: "#fff",
                "margin-bottom": "15px"
              }
            },
            [
              _c(
                "a-button",
                {
                  staticClass: "search-btn-item btn-blue-line",
                  staticStyle: { "margin-bottom": "15px" },
                  attrs: { disabled: _vm.openDisabled },
                  on: { click: _vm.onOpen }
                },
                [_vm._v("开立祺信")]
              ),
              _vm._v(" "),
              _c(
                "a-button",
                { attrs: { type: "primary" }, on: { click: _vm.onOtherOpen } },
                [_vm._v("其他开立")]
              ),
              _vm._v(" "),
              _c(
                "a-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onOtherOpenlists }
                },
                [_vm._v("批量开票")]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-common common common-scroll" },
        [
          _vm.selectedRows.length
            ? _c(
                "div",
                { staticClass: "table-check-bar" },
                [
                  _vm._v("\n      已选择：\n      "),
                  _c("span", { staticClass: "text-color-blue" }, [
                    _vm._v(_vm._s(_vm.selectedRows.length) + " 条")
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "\n        " + _vm._s(_vm.selectName) + "：\n        "
                    ),
                    _c("span", { staticClass: "text-color-orange" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm._f("splitK")(_vm.totalPayable(_vm.selectedRows))
                          ) +
                          " 元\n        "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.exDateCounts
                    ? [
                        _c("span", [
                          _vm._v("距到期日还有 "),
                          _c("span", { staticClass: "text-color-orange" }, [
                            _vm._v(_vm._s(_vm.exDateCounts) + " 天")
                          ])
                        ])
                      ]
                    : _vm._e()
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c("a-table", {
            attrs: {
              size: "middle",
              columns: _vm.columns,
              "row-key": function(record) {
                return record.id
              },
              "data-source": _vm.tableData,
              pagination: _vm.pagination,
              loading: _vm.loading,
              bordered: "",
              locale: { emptyText: "暂无数据" },
              "row-selection": _vm.tableSelect,
              scroll: {}
            },
            on: { change: _vm.handleTableChange },
            scopedSlots: _vm._u([
              {
                key: "cyCode",
                fn: function(text, record) {
                  return [
                    _c(
                      "div",
                      { staticClass: "spceCenter" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "ellipsis",
                            staticStyle: { flex: "1" },
                            attrs: { title: text }
                          },
                          [
                            _vm._v(
                              "\n            " + _vm._s(text) + "\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a-popover",
                          {
                            attrs: {
                              title:
                                "不通过原因-" +
                                (record.checkType == "auto"
                                  ? "自助查验"
                                  : "平台查验")
                            }
                          },
                          [
                            _c("template", { slot: "content" }, [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    color: "#666",
                                    "max-width": "200px"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(record.resultMsg || "暂无原因") +
                                      "\n              "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            record.resultCode == 2
                              ? _c(
                                  "svg",
                                  {
                                    staticClass: "payable-icon",
                                    attrs: { "aria-hidden": "true" }
                                  },
                                  [
                                    _c("use", {
                                      attrs: {
                                        "xlink:href": "#gold-icon-tishi"
                                      }
                                    })
                                  ]
                                )
                              : _vm._e()
                          ],
                          2
                        )
                      ],
                      1
                    )
                  ]
                }
              },
              {
                key: "payableAmount",
                fn: function(text, record) {
                  return [
                    _c("a-input", {
                      staticClass: "text-center",
                      on: {
                        blur: function($event) {
                          return _vm.gldAmtCheck(record)
                        }
                      },
                      model: {
                        value: record.gldAmt,
                        callback: function($$v) {
                          _vm.$set(record, "gldAmt", $$v)
                        },
                        expression: "record.gldAmt"
                      }
                    }),
                    _vm._v(" "),
                    !record.gldAmtCheck
                      ? _c(
                          "div",
                          { staticClass: "text-color-orange text-center" },
                          [
                            _vm._v(
                              "\n          输入金额不能大于" +
                                _vm._s(_vm._f("splitK")(record.canEstbGldBal)) +
                                "元\n        "
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                }
              },
              {
                key: "rcvbBal",
                fn: function(text) {
                  return [
                    _vm._v(
                      "\n        " + _vm._s(_vm._f("splitK")(text)) + "\n      "
                    )
                  ]
                }
              },
              {
                key: "canEstbGldBal",
                fn: function(text) {
                  return [
                    _vm._v(
                      "\n        " + _vm._s(_vm._f("splitK")(text)) + "\n      "
                    )
                  ]
                }
              },
              {
                key: "billTime",
                fn: function(text) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("dateFormat")(text, "YYYY-mm-dd")) +
                        "\n      "
                    )
                  ]
                }
              },
              {
                key: "invoiceType",
                fn: function(text) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("invoiceTypeFilter")(text)) +
                        "\n      "
                    )
                  ]
                }
              },
              {
                key: "invoiceCode",
                fn: function(text, record) {
                  return [
                    record.invoiceCode
                      ? _c("span", [_vm._v(_vm._s(record.invoiceCode))])
                      : _vm._e(),
                    _vm._v(" "),
                    !record.invoiceCode ? _c("span", [_vm._v("--")]) : _vm._e()
                  ]
                }
              },
              {
                key: "invoiceNumber",
                fn: function(text, record) {
                  return [
                    _c(
                      "a",
                      {
                        on: {
                          click: function($event) {
                            return _vm.toInvoiceInfo(record)
                          }
                        }
                      },
                      [_vm._v(_vm._s(text))]
                    )
                  ]
                }
              },
              {
                key: "invoiceAmountWithVat",
                fn: function(text) {
                  return [
                    _vm._v(
                      "\n        " + _vm._s(_vm._f("splitK")(text)) + "\n      "
                    )
                  ]
                }
              },
              {
                key: "checkType",
                fn: function(text) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("checkTypeFilter")(text)) +
                        "\n      "
                    )
                  ]
                }
              },
              {
                key: "contract",
                fn: function(text, record) {
                  return [
                    text
                      ? _c(
                          "a",
                          {
                            on: {
                              click: function($event) {
                                return _vm.contractInfoOpen(record)
                              }
                            }
                          },
                          [_vm._v(_vm._s(text))]
                        )
                      : _c("span", [_vm._v("--")])
                  ]
                }
              },
              {
                key: "voucherCodes",
                fn: function(text, record) {
                  return [
                    _c("span", { attrs: { title: text } }, [
                      text
                        ? _c(
                            "a",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.toDeliveryCreate("detail", record)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n            " + _vm._s(text) + "\n          "
                              )
                            ]
                          )
                        : _c("span", [_vm._v("--")])
                    ])
                  ]
                }
              },
              {
                key: "operation",
                fn: function(text, record) {
                  return [
                    _vm.voucherCodesOper("add", record)
                      ? _c(
                          "a",
                          {
                            on: {
                              click: function($event) {
                                return _vm.toDeliveryCreate("add", record)
                              }
                            }
                          },
                          [_vm._v("上传")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.voucherCodesOper("edit", record)
                      ? _c(
                          "a",
                          {
                            on: {
                              click: function($event) {
                                return _vm.toDeliveryCreate("edit", record)
                              }
                            }
                          },
                          [_vm._v("编辑")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.voucherCodesOper("detail", record)
                      ? _c(
                          "a",
                          {
                            on: {
                              click: function($event) {
                                return _vm.toDeliveryCreate("detail", record)
                              }
                            }
                          },
                          [_vm._v("查看")]
                        )
                      : _vm._e()
                  ]
                }
              },
              {
                key: "operationEdit",
                fn: function(text, record) {
                  return [
                    _c(
                      "a",
                      {
                        on: {
                          click: function($event) {
                            return _vm.toInvoiceInfo(record)
                          }
                        }
                      },
                      [_vm._v("查看")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        on: {
                          click: function($event) {
                            return _vm.toInvoiceEdit(record)
                          }
                        }
                      },
                      [_vm._v("编辑")]
                    )
                  ]
                }
              },
              {
                key: "openGold",
                fn: function(text, record) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("splitK")(record.gldAmt)) +
                        "\n        "
                    )
                  ]
                }
              },
              {
                key: "openedAmount",
                fn: function(text, record) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.openedAmount(record, _vm.canEstbGldBal)) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              class: {
                "table-total": _vm.pagination.total > 0,
                "table-total-none": _vm.pagination.total == 0
              }
            },
            [
              _vm._v("\n      共有记录：\n      "),
              _c("span", { staticClass: "text-color-blue" }, [
                _vm._v(" " + _vm._s(_vm.pagination.total) + " 条 ")
              ]),
              _vm._v("\n      " + _vm._s(_vm.totalName) + "：\n      "),
              _c("span", { staticClass: "text-color-orange" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm._f("splitK")(_vm.totalPayable(_vm.tableData))) +
                    " 元\n      "
                )
              ]),
              _vm._v("\n      可开立余额(元)：\n      "),
              _c("span", { staticClass: "text-color-orange" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm._f("splitK")(
                        _vm.totalPayable(_vm.tableData, "canEstbGldBal")
                      )
                    ) +
                    " 元\n      "
                )
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("invoiceInfo", {
        ref: "invoiceInfo",
        attrs: { readonly: true, info: _vm.curRow },
        on: {
          "update:info": function($event) {
            _vm.curRow = $event
          }
        }
      }),
      _vm._v(" "),
      _c("invoiceInfo", {
        ref: "invoiceEdit",
        attrs: { readonly: false, info: _vm.curRow, btns: ["save", "close"] },
        on: {
          "update:info": function($event) {
            _vm.curRow = $event
          },
          save: _vm.successHandle,
          check: _vm.successHandle
        }
      }),
      _vm._v(" "),
      _c("contractDialog", {
        ref: "contractEdit",
        attrs: {
          title: "匹配合同",
          readonly: false,
          selectedRows: _vm.selectedRows,
          btns: ["save", "close"]
        },
        on: {
          "update:selectedRows": function($event) {
            _vm.selectedRows = $event
          },
          "update:selected-rows": function($event) {
            _vm.selectedRows = $event
          },
          save: _vm.contractSuccessHandle
        }
      }),
      _vm._v(" "),
      _c("contractDialog", {
        ref: "contractInfo",
        attrs: { title: "匹配合同详情", readonly: true, info: _vm.curRow },
        on: {
          "update:info": function($event) {
            _vm.curRow = $event
          }
        }
      }),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: "导入",
            width: "450px",
            loading: _vm.importDialogLoad,
            destroyOnClose: ""
          },
          on: { ok: _vm.checkSeller, cancel: _vm.closeImport },
          model: {
            value: _vm.modalShowImport,
            callback: function($$v) {
              _vm.modalShowImport = $$v
            },
            expression: "modalShowImport"
          }
        },
        [
          _c(
            "a-form-model",
            {
              ref: "ruleFormImport",
              attrs: {
                model: _vm.importData,
                "label-col": { span: 8 },
                "wrapper-col": { span: 13 }
              }
            },
            [
              _c(
                "a-form-model-item",
                {
                  staticStyle: { "margin-bottom": "8px" },
                  attrs: { label: " ", prop: "importType", colon: false }
                },
                [
                  _c(
                    "a-radio-group",
                    {
                      attrs: { name: "importType" },
                      model: {
                        value: _vm.importData.importType,
                        callback: function($$v) {
                          _vm.$set(_vm.importData, "importType", $$v)
                        },
                        expression: "importData.importType"
                      }
                    },
                    _vm._l(_vm.importType, function(item) {
                      return _c(
                        "a-radio",
                        { key: item.value, attrs: { value: item.value } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.name) +
                              "\n          "
                          )
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-form-model-item",
                {
                  staticStyle: { "margin-bottom": "8px" },
                  attrs: { label: "卖方名称", prop: "importType" }
                },
                [
                  _c("select-search", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.importData.importType == 2,
                        expression: "importData.importType == 2"
                      }
                    ],
                    attrs: {
                      searchSource: true,
                      dataSource: _vm.importTypeOption,
                      headNameFirst: "卖方名称",
                      headNameSecond: "社会信用代码",
                      valuePorp: "orgCode",
                      labelPorp: "userName"
                    },
                    on: {
                      handleChange: _vm.changeTenant,
                      handleSearch: _vm.handleSearchType
                    },
                    model: {
                      value: _vm.importData.tenantObj2,
                      callback: function($$v) {
                        _vm.$set(_vm.importData, "tenantObj2", $$v)
                      },
                      expression: "importData.tenantObj2"
                    }
                  }),
                  _vm._v(" "),
                  _c("select-search", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.importData.importType == 1,
                        expression: "importData.importType == 1"
                      }
                    ],
                    attrs: {
                      searchSource: true,
                      dataSource: _vm.importOption,
                      headNameFirst: "卖方名称",
                      headNameSecond: "社会信用代码",
                      valuePorp: "cstOrgCode",
                      labelPorp: "cstNm"
                    },
                    on: {
                      handleChange: _vm.changeTenant,
                      handleSearch: _vm.handleSearchImport
                    },
                    model: {
                      value: _vm.importData.tenantObj,
                      callback: function($$v) {
                        _vm.$set(_vm.importData, "tenantObj", $$v)
                      },
                      expression: "importData.tenantObj"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-form-model-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.importData.importType == 1,
                      expression: "importData.importType == 1"
                    }
                  ],
                  staticStyle: { "margin-bottom": "8px" },
                  attrs: { label: "卖方社会信用代码", prop: "importType" }
                },
                [
                  _c("a-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.importData.tenantObj.key,
                      callback: function($$v) {
                        _vm.$set(_vm.importData.tenantObj, "key", $$v)
                      },
                      expression: "importData.tenantObj.key"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.importData.importType == 2
                ? _c(
                    "a-form-model-item",
                    { attrs: { label: " ", colon: false } },
                    [
                      _c("span", { staticClass: "text-color-red" }, [
                        _vm._v(_vm._s(_vm.importErrText))
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("confirmModal", {
        ref: "modalGoldOpen",
        attrs: {
          confirmTableData: _vm.confirmTableData,
          overdueRate: _vm.otherform.overdueRate
        },
        on: {
          "update:confirmTableData": function($event) {
            _vm.confirmTableData = $event
          },
          "update:confirm-table-data": function($event) {
            _vm.confirmTableData = $event
          },
          ok: _vm.modalOk,
          "update:overdueRate": function($event) {
            return _vm.$set(_vm.otherform, "overdueRate", $event)
          },
          "update:overdue-rate": function($event) {
            return _vm.$set(_vm.otherform, "overdueRate", $event)
          }
        }
      }),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            width: "420px",
            title: "祺信开立",
            visible: _vm.modalShowPwd,
            maskClosable: false,
            footer: null
          },
          on: { cancel: _vm.modalCancel }
        },
        [
          _vm.confirmModalData
            ? _c("confirmPasswordModal", {
                attrs: {
                  confirmData: _vm.confirmTableData,
                  confirmModalData: _vm.confirmModalData,
                  overdueRate: _vm.otherform.overdueRate
                },
                on: {
                  "update:confirmData": function($event) {
                    _vm.confirmTableData = $event
                  },
                  "update:confirm-data": function($event) {
                    _vm.confirmTableData = $event
                  },
                  "update:confirmModalData": function($event) {
                    _vm.confirmModalData = $event
                  },
                  "update:confirm-modal-data": function($event) {
                    _vm.confirmModalData = $event
                  },
                  "update:overdueRate": function($event) {
                    return _vm.$set(_vm.otherform, "overdueRate", $event)
                  },
                  "update:overdue-rate": function($event) {
                    return _vm.$set(_vm.otherform, "overdueRate", $event)
                  },
                  ok: _vm.modalOkPwd,
                  cancel: _vm.modalCancel
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-spin",
        { attrs: { spinning: _vm.loading } },
        [
          _c(
            "a-modal",
            {
              attrs: {
                "confirm-loading": _vm.confirmLoading,
                "on-ok": "handleOk",
                width: "900px"
              },
              on: { cancel: _vm.handleotherCancel },
              model: {
                value: _vm.otherOpen,
                callback: function($$v) {
                  _vm.otherOpen = $$v
                },
                expression: "otherOpen"
              }
            },
            [
              _c("template", { slot: "title" }, [
                _vm.title == "其他开立"
                  ? _c("div", [
                      _c("div", [_vm._v(_vm._s(_vm.title))]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "font-size": "12px",
                            color: "#B3B3B3",
                            "margin-top": "5px"
                          }
                        },
                        [
                          _vm._v(
                            "\n            通过无发票开立的祺信，无法进行融资\n          "
                          )
                        ]
                      )
                    ])
                  : _c("div", [_vm._v(_vm._s(_vm.title) + " ")])
              ]),
              _vm._v(" "),
              _c(
                "a-form-model",
                {
                  ref: "rulesotherform",
                  attrs: {
                    model: _vm.otherform,
                    rules: _vm.rules,
                    "label-col": { span: 8 },
                    "wrapper-col": { span: 16 }
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between"
                      }
                    },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          staticStyle: { width: "320px" },
                          attrs: { label: "开立方", prop: "estbName" }
                        },
                        [
                          _c("a-input", {
                            staticStyle: { width: "210px" },
                            attrs: { disabled: true },
                            model: {
                              value: _vm.otherform.estbName,
                              callback: function($$v) {
                                _vm.$set(_vm.otherform, "estbName", $$v)
                              },
                              expression: "otherform.estbName"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-form-model-item",
                        {
                          staticStyle: { width: "245px" },
                          attrs: { label: "", prop: "" }
                        },
                        [
                          _c(
                            "a-button",
                            {
                              attrs: { primary: "" },
                              on: { click: _vm.handlehistoryInfo }
                            },
                            [_vm._v("引入历史开票信息")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-form-model-item",
                    {
                      staticStyle: {
                        "margin-bottom": "8px",
                        "margin-left": "128px",
                        width: "320px"
                      },
                      attrs: { prop: "importType", colon: false }
                    },
                    [
                      _c(
                        "a-radio-group",
                        {
                          attrs: { name: "importType" },
                          model: {
                            value: _vm.importData.importType,
                            callback: function($$v) {
                              _vm.$set(_vm.importData, "importType", $$v)
                            },
                            expression: "importData.importType"
                          }
                        },
                        _vm._l(_vm.importType, function(item) {
                          return _c(
                            "a-radio",
                            {
                              key: item.value,
                              attrs: { value: item.value },
                              on: {
                                click: function($event) {
                                  return _vm.hadleRadio(item.value)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(item.name) +
                                  "\n            "
                              )
                            ]
                          )
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.importData.importType == 1
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              staticStyle: { width: "320px" },
                              attrs: { label: "接收方", prop: "rcPtyName" }
                            },
                            [
                              _c("select-search", {
                                staticStyle: { width: "210px" },
                                attrs: {
                                  searchSource: true,
                                  dataSource: _vm.importOption,
                                  other: true,
                                  headNameFirst: "接收方名称",
                                  headNameSecond: "社会信用代码",
                                  valuePorp: "cstOrgCode",
                                  labelPorp: "cstNm"
                                },
                                on: {
                                  handleChange: _vm.changeTenant,
                                  handleSearch: _vm.handleSearchImport
                                },
                                model: {
                                  value: _vm.importData.tenantObj,
                                  callback: function($$v) {
                                    _vm.$set(_vm.importData, "tenantObj", $$v)
                                  },
                                  expression: "importData.tenantObj"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "a-form-model-item",
                            {
                              staticStyle: { width: "465px" },
                              attrs: {
                                label: "社会信用代码",
                                prop: "cstOrgCode"
                              }
                            },
                            [
                              _c("a-input", {
                                staticStyle: { width: "210px" },
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.otherform.cstOrgCode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.otherform, "cstOrgCode", $$v)
                                  },
                                  expression: "otherform.cstOrgCode"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.importData.importType == 2
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c(
                            "div",
                            [
                              _c(
                                "a-form-model-item",
                                {
                                  staticStyle: { width: "320px" },
                                  attrs: {
                                    label: "接收方",
                                    prop: "tenantName2"
                                  }
                                },
                                [
                                  _c("select-search", {
                                    staticStyle: { width: "210px" },
                                    attrs: {
                                      searchSource: true,
                                      dataSource: _vm.importOption,
                                      other: true,
                                      headNameFirst: "接收方名称",
                                      headNameSecond: "社会信用代码",
                                      valuePorp: "orgCode",
                                      labelPorp: "userName"
                                    },
                                    on: {
                                      handleChange: _vm.changeTenantJR,
                                      handleSearch: _vm.handleBlur
                                    },
                                    model: {
                                      value: _vm.importData2.tenantObj,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.importData2,
                                          "tenantObj",
                                          $$v
                                        )
                                      },
                                      expression: "importData2.tenantObj"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.importErrText
                                ? _c(
                                    "a-form-model-item",
                                    {
                                      staticStyle: {
                                        "margin-bottom": "8px",
                                        "margin-left": "108px",
                                        width: "250px",
                                        "white-space": "nowrap"
                                      },
                                      attrs: { label: "", colon: false }
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "text-color-red" },
                                        [_vm._v(_vm._s(_vm.importErrText))]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "a-form-model-item",
                            {
                              staticStyle: { width: "465px" },
                              attrs: { label: "社会信用代码", prop: "OrgCode" }
                            },
                            [
                              _c("a-input", {
                                staticStyle: { width: "210px" },
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.otherform.OrgCode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.otherform, "OrgCode", $$v)
                                  },
                                  expression: "otherform.OrgCode"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between"
                      }
                    },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          staticStyle: { width: "255px" },
                          attrs: { label: "开立金额", prop: "gldAmt" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "spaceLeft",
                              staticStyle: {
                                "flex-wrap": "nowrap",
                                width: "400px"
                              }
                            },
                            [
                              _c(
                                "a-popover",
                                { attrs: { title: "开立金额" } },
                                [
                                  _c("template", { slot: "content" }, [
                                    _c(
                                      "p",
                                      { staticStyle: { width: "300px" } },
                                      [
                                        _vm._v(
                                          "\n                    开立金额只能输入数字和小数点，整数不分最多支持10位，小数点后支持2位\n                  "
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("a-icon", {
                                    staticClass: "common-question",
                                    attrs: { type: "question-circle" }
                                  })
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center"
                                  }
                                },
                                [
                                  _c("a-input-number", {
                                    staticStyle: { width: "210px" },
                                    attrs: {
                                      placeholder: "请输入",
                                      min: 0,
                                      max: 9999999999.99,
                                      precision: 2
                                    },
                                    model: {
                                      value: _vm.otherform.gldAmt,
                                      callback: function($$v) {
                                        _vm.$set(_vm.otherform, "gldAmt", $$v)
                                      },
                                      expression: "otherform.gldAmt"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a-form-model-item",
                        {
                          staticStyle: { width: "465px" },
                          attrs: { label: "兑付日期", prop: "exDay" }
                        },
                        [
                          _c("a-date-picker", {
                            staticStyle: { width: "210px" },
                            attrs: {
                              valueFormat: "YYYY-MM-DD",
                              placeholder: "请选择",
                              "disabled-date": _vm.disabledDate1
                            },
                            model: {
                              value: _vm.otherform.exDay,
                              callback: function($$v) {
                                _vm.$set(_vm.otherform, "exDay", $$v)
                              },
                              expression: "otherform.exDay"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between"
                      }
                    },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          staticStyle: { width: "320px" },
                          attrs: { label: "是否可变更", prop: "canBeModified" }
                        },
                        [
                          _c(
                            "a-select",
                            {
                              staticStyle: { width: "210px" },
                              attrs: {
                                allowClear: true,
                                "option-label-prop": "label"
                              },
                              model: {
                                value: _vm.otherform.canBeModified,
                                callback: function($$v) {
                                  _vm.$set(_vm.otherform, "canBeModified", $$v)
                                },
                                expression: "otherform.canBeModified"
                              }
                            },
                            _vm._l(_vm.canBeModifiedList, function(item) {
                              return _c(
                                "a-select-option",
                                {
                                  key: item.value,
                                  attrs: { value: item.value, label: item.name }
                                },
                                [_vm._v(_vm._s(item.name))]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-form-model-item",
                        {
                          staticStyle: { width: "500px" },
                          attrs: {
                            label: "罚息利率：",
                            prop: "overdueRate ",
                            rules: [
                              {
                                required: true,
                                whitespace: true,
                                validator: _vm.overdueRateCheck1
                              }
                            ]
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "spaceLeft",
                              staticStyle: {
                                "flex-wrap": "nowrap",
                                width: "400px"
                              }
                            },
                            [
                              _c(
                                "a-popover",
                                { attrs: { title: "罚息利率：" } },
                                [
                                  _c("template", { slot: "content" }, [
                                    _c(
                                      "p",
                                      { staticStyle: { width: "300px" } },
                                      [
                                        _vm._v(
                                          "\n                    若勾选1年期LRP，系统将自动转化为日利率。（日利率=年利率/360，日利率保留四位小数，第四位小数加1）\n                  "
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("a-icon", {
                                    staticClass: "common-question",
                                    attrs: { type: "question-circle" }
                                  })
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticStyle: { width: "150px" } },
                                [
                                  _c("a-input", {
                                    attrs: {
                                      disabled: _vm.isLRP1,
                                      placeholder: "请输入",
                                      suffix: "日利率(%)"
                                    },
                                    model: {
                                      value: _vm.otherform.overdueRate,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.otherform,
                                          "overdueRate",
                                          $$v
                                        )
                                      },
                                      expression: "otherform.overdueRate"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.LRP
                                ? _c(
                                    "a-checkbox",
                                    {
                                      staticStyle: { "margin-left": "10px" },
                                      model: {
                                        value: _vm.isLRP1,
                                        callback: function($$v) {
                                          _vm.isLRP1 = $$v
                                        },
                                        expression: "isLRP1"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "1年期LPR(" + _vm._s(_vm.LRP) + "%)"
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.title == "其他开立"
                    ? _c(
                        "div",
                        [
                          _c("otherFileUpload", {
                            ref: "childFileUpload",
                            attrs: {
                              tblBlId: _vm.tblBlId,
                              introducedSource: _vm.introducedSource
                            },
                            on: { receiveFileTblBlId: _vm.receiveFileTblBlId }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { display: "flex" } },
                [
                  _c("a-checkbox", {
                    staticStyle: { margin: "0 5px 16px 15px" },
                    model: {
                      value: _vm.isOthercheck,
                      callback: function($$v) {
                        _vm.isOthercheck = $$v
                      },
                      expression: "isOthercheck"
                    }
                  }),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v("已阅读并同意所勾选的"),
                    _c("a", { on: { click: _vm.openFile } }, [
                      _vm._v("《付款承诺函》")
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "template",
                { slot: "footer" },
                [
                  _c("a-button", { on: { click: _vm.handleotherCancel } }, [
                    _vm._v("\n          关闭\n        ")
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary", loading: _vm.loading },
                      on: { click: _vm.handleOk }
                    },
                    [_vm._v("\n          确定\n        ")]
                  )
                ],
                1
              )
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "a-modal",
            {
              attrs: {
                title: "其他开立",
                width: "420px",
                "on-ok": "handleOther"
              },
              model: {
                value: _vm.otherOpenTxnpwd,
                callback: function($$v) {
                  _vm.otherOpenTxnpwd = $$v
                },
                expression: "otherOpenTxnpwd"
              }
            },
            [
              _c("a-spin", { attrs: { spinning: _vm.modalLoad } }, [
                _c("div", { staticClass: "spaceCenter" }, [
                  _c("div", [
                    _c("div", { staticClass: "spaceLeft item-box" }, [
                      _c("label", [_vm._v("祺信笔数：")]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "text-color-blue",
                          staticStyle: { "margin-right": "5px" }
                        },
                        [_vm._v("1\n              ")]
                      ),
                      _vm._v("\n              笔\n            ")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "spaceLeft item-box" }, [
                      _c("label", [_vm._v("祺信面额：")]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "text-color-gold",
                          staticStyle: { "margin-right": "5px" }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.otherform.gldAmt) + "\n              "
                          )
                        ]
                      ),
                      _vm._v("\n              元\n            ")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "spaceLeft item-box" },
                      [
                        _c("label", [_vm._v("交易密码：")]),
                        _vm._v(" "),
                        _c("a-input", {
                          staticClass: "item-input",
                          attrs: { type: "password" },
                          model: {
                            value: _vm.txnPwd,
                            callback: function($$v) {
                              _vm.txnPwd = $$v
                            },
                            expression: "txnPwd"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "template",
                { slot: "footer" },
                [
                  _c("a-button", { on: { click: _vm.handleCancel } }, [
                    _vm._v("\n          关闭\n        ")
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary", loading: _vm.loading },
                      on: { click: _vm.handleOther }
                    },
                    [_vm._v("\n          确定\n        ")]
                  )
                ],
                1
              )
            ],
            2
          ),
          _vm._v(" "),
          _c("fileView", {
            ref: "fileView",
            attrs: { artcCntnt: _vm.artcCntnt },
            on: {
              "update:artcCntnt": function($event) {
                _vm.artcCntnt = $event
              },
              "update:artc-cntnt": function($event) {
                _vm.artcCntnt = $event
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("deliveryVoucherDialog", {
        ref: "deliveryVoucherDialog",
        attrs: { details: _vm.deliveryVoucherDialogState },
        on: {
          save: function($event) {
            return _vm.refresh()
          }
        }
      }),
      _vm._v(" "),
      _c("batchInvoicingDialog", {
        ref: "batchInvoicingDialog",
        attrs: { isShow: _vm.selectedRows }
      }),
      _vm._v(" "),
      _c("historyInfo", {
        ref: "historyInfo",
        on: { "select-history": _vm.handleSelectHistory }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14df4733", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14df4733","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bill-manage/payable/list.vue
// module id = iVCx
// module chunks = 1